












import { defineComponent } from "@nuxtjs/composition-api";
export default defineComponent({
  name: "MoominImage",
  methods: {
    getImage() { 
      return this?.image?.desktop || `${this.$config.productionURL}/_ipx/f_webp,q_100,s_240x240/images/product_placeholder.svg`;
    },
    getAltText() { 
      return this?.image?.alt || '';
    }
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
});
